module.exports = __webpack_public_path__ + "img/electronic_enabled.7a4770fb.svg";